import { api_host } from '../constants'
import { apiFetch } from './apiRequestHandler'

export const getSites = async (archived = false) => {
  return await apiFetch(`${api_host}/sites/list?archived=${archived}`)
}

export const getSiteByUri = async (uri) => {
  return await apiFetch(`${api_host}/sites/by-uri/${uri}`)
}

export const createSite = async (data) => {
  return await apiFetch(`${api_host}/sites/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
}

export const updateSite = async (id, data) => {
  return await apiFetch(`${api_host}/sites/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
}

export const deleteSite = async (id) => {
  return await apiFetch(`${api_host}/sites/${id}`, {
    method: 'DELETE'
  })
}

export const updateSiteVersion = async (uri, oldVersion, newVersion) => {
  return await apiFetch(`${api_host}/sites/update-site-version`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      uri, oldVersion, newVersion
    })
  })
}

export const getSiteVersions = async (uri) => {
  return await apiFetch(`${api_host}/sites/versions/${uri}`)
}

export const getSiteWithVersion = async (uri, version) => {
  return await apiFetch(`${api_host}/sites/by-uri-version/${uri}/${version}`)
}

export const setSiteVersion = async (uri, body) => {
  return await apiFetch(`${api_host}/sites/set-site-version/${uri}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })
}

export const deleteSiteVersion = async (uri, version) => {
  return await apiFetch(`${api_host}/sites/delete-site-version/${uri}/${version}`, {
    method: 'DELETE'
  })
}

export const archiveSite = async (uri) => {
  return await apiFetch(`${api_host}/sites/archive/${uri}`, {
    method: 'DELETE'
  })
}

export const unArchiveSite = async (uri) => {
  return await apiFetch(`${api_host}/sites/unarchive/${uri}`, {
    method: 'DELETE'
  })
}

export const uploadFile = async (file, key = '') => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('key', key)

  return await apiFetch(`${api_host}/upload-file`, {
    method: 'POST',
    body: formData
  })
}

export const getFileLink = async (key) => {
  return await apiFetch(`${api_host}/s3/${key}`)
}

export const duplicateSite = async (source, dest) => {
  return await apiFetch(`${api_host}/sites/duplicate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ source, dest })
  })
}

export const exportSite = async (siteId) => {
  return await apiFetch(`${api_host}/sites/export-site?uri=${siteId}`)
}

export const importSite = async (formData) => {
  return await apiFetch(`${api_host}/sites/import-site`, {
    method: 'POST',
    body: formData
  })
}
